import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';

export default function useCurrentUserEmployee() {
  return useRetrieve({
    url: 'CurrentUser/Employee',
    staleTime: Infinity,
  });
}
